<div class="account-pages my-5 pt-5">
  <div class="container">

    <!-- Step Progress Indicator -->
    <div class="row justify-content-center mb-4">
      <div class="col-lg-8">
        <div class="card shadow-sm border-0" style="background: linear-gradient(135deg, #556ee6 0%, #6f86ea 100%);">
          <div class="card-body py-3 px-4">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div>
                <small class="text-white-50 text-uppercase fw-semibold">Onboarding Progress</small>
                <h6 class="mb-0 mt-1">
                  <span class="text-white">Step {{ currentStep }} </span>
                  <span class="text-white">of {{ totalSteps }}</span>
                </h6>
              </div>
              <div class="text-end">
                <span class="badge bg-white font-size-12 px-3 py-2" style="color: #556ee6;">
                  <i class="bx bx-map me-1"></i> Location
                </span>
              </div>
            </div>
            <div class="progress" style="height: 8px; border-radius: 10px; background-color: rgba(255,255,255,.2);">
              <div class="progress-bar bg-white" role="progressbar"
                   [style.width.%]="progressPercentage"
                   style="border-radius: 10px; transition: width .6s ease;"></div>
            </div>
            <div class="d-flex justify-content-between mt-2">
              <small class="text-white-50"><i class="bx bx-map-pin me-1"></i>Where you're based</small>
              <small class="text-white-50 font-size-11">{{ progressPercentage }}% Complete</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body p-4">

            <div *ngIf="isLoading" class="text-center py-5">
              <div class="spinner-border text-primary" role="status"></div>
            </div>

            <ng-container *ngIf="!isLoading">
              <h4 class="mb-1">Where is {{ organizationName }} based?</h4>
              <p class="text-muted">
                We use this to show message prices in the right country's rates, and to get
                send times right in your local timezone.
              </p>

              <div class="row g-3 mt-2">
                <div class="col-md-6">
                  <label class="form-label fw-semibold">Country</label>
                  <select class="form-select" [(ngModel)]="countryIso" name="countryIso">
                    <option *ngFor="let c of countries" [value]="c.iso">
                      {{ flagFor(c.iso) }} {{ c.name }}
                    </option>
                  </select>
                  <div class="form-text">
                    Message pricing varies by country — this picks the rates you'll be quoted.
                  </div>
                </div>

                <div class="col-md-6">
                  <label class="form-label fw-semibold">Timezone</label>
                  <select class="form-select" [(ngModel)]="timezone" name="timezone">
                    <option value="">Not set</option>
                    <option *ngFor="let tz of timezones" [value]="tz">{{ tz }}</option>
                  </select>
                  <div class="form-text">
                    We've guessed this from your browser. Scheduled sends use it.
                  </div>
                </div>
              </div>

              <div class="alert alert-light border mt-4">
                <i class="bx bx-info-circle me-1"></i>
                You can change both later in <strong>Organization &rarr; Settings</strong>.
              </div>

              <div class="d-grid mt-4">
                <button class="btn btn-primary btn-lg" (click)="save()" [disabled]="isSaving">
                  <span *ngIf="!isSaving">Save &amp; Continue</span>
                  <span *ngIf="isSaving">
                    <span class="spinner-border spinner-border-sm me-2" role="status"></span>Saving…
                  </span>
                </button>
              </div>
            </ng-container>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
